import { render, staticRenderFns } from "./identity-card-component.vue?vue&type=template&id=56615846&scoped=true"
import script from "./identity-card-component.ts?vue&type=script&lang=ts&external"
export * from "./identity-card-component.ts?vue&type=script&lang=ts&external"
import style0 from "./identity-card-component.scss?vue&type=style&index=0&id=56615846&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56615846",
  null
  
)

export default component.exports